"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = getBoundingClientRect;

function getBoundingClientRect(el) {
  var rect = el.getBoundingClientRect();
  var x;
  var y;

  if (rect.x === undefined) {
    x = rect.left;
  } else {
    x = rect.x;
  }

  if (rect.y === undefined) {
    y = rect.top;
  } else {
    y = rect.y;
  }

  return {
    left: rect.left,
    top: rect.top,
    right: rect.right,
    bottom: rect.bottom,
    x: x,
    y: y,
    width: rect.width,
    height: rect.height
  };
}
//# sourceMappingURL=getBoundingClientRect.js.map